import React from "react";
import { FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function MobileProfileMenuIcon({ data, index, handelSlider }) {
    return (
        <Link
            to={data?.linkTo}
            className={`sidebar-li block min-h-11 p-1 rounded-md ${`#${data?.linkTo}` === window?.location?.hash ? 'active' : ''}`}
            key={index}
            onClick={() => { handelSlider() }}
        >
            {/* <li className={" flex gap-4 items-center text-navLink py-2 px-0 "}>
                <div className="w-10 h-10 bg-white shadow-sm border rounded-full text-white p-2 justify-center items-center flex">{data?.icon}</div>
                <p className="text-navLink baseText justify-center items-center flex">{data?.name}</p>
                <div className="size-9 rounded-full ms-auto inline-flex justify-center items-center">
                    <FiChevronRight className="text-lg text-coalBlack" />
                </div>
            </li> */}
            <li className={' flex gap-4 items-center text-navLink p-2 '} >
                <div className="w-6 h-6">{data?.icon}</div>
                <p className="text-navLink baseText">{data?.name}</p>
                <div className="size-9 rounded-full ms-auto inline-flex justify-center items-center">
                    <FiChevronRight className="text-lg text-coalBlack" />
                </div>
            </li>
        </Link>
    )
}